<template>
    <div>
        <div class="text-xs-center" v-if="!items">
            <br/><br/>
            <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
            ></v-progress-circular> &nbsp;&nbsp; BUSCANDO CAIXAS
        </div>

        <v-list two-line subheader v-if="items && items.length">

            <template v-for="(item, index) in items">
                <div :key="index">
                    <v-divider :inset="item.inset"  ></v-divider>
                    <v-list-tile avatar :to="'/caixa/pacpon/' + item._id">

                        <v-list-tile-avatar>
                            <v-icon :class="'blue lighten-1 white--text'">network_wifi</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.nome }}</v-list-tile-title>
                        </v-list-tile-content>

                    </v-list-tile>
                </div>
            </template>

        </v-list>

        <v-container v-if="items && !items.length">
            <v-alert
                    :value="true"
                    color="info"
                    icon="info"
                    outline
            >
                NENHUM PACPON NESTA CAIXA
            </v-alert>
        </v-container>

    </div>

</template>

<script>
    import { Caixas } from "../../class/caixas"
    import { EventBus } from "../../utils/event-bus"
    export default {
        name: "PacponNaCto",
        data () {
            return {
                items: null,
                interval: null
            }
        },
        props: {
            id: {
                default: null
            }
        },
        beforeDestroy () {
            // clearInterval(this.interval);
        },
        beforeMount () {
            EventBus.$on("reloaded", () => this.load());
            this.load();
            // this.interval = setInterval(() => this.load(), 60000);
        },
        methods: {
            load () {
                Caixas
                    .pacponByCto(this.id)
                    .then((json) => {
                        this.items = json.data
                    });
            }
        }
    }
</script>

<style scoped>

</style>
